import { Texture, Rectangle, SCALE_MODES } from 'pixi.js';

/**
 * Currently only supporting image tiles, but there are other tileset types in Tiled.
 */
export class Tileset {
    static type = {
        tile: "TILE",
        imageTiles: "IMAGETILES"
    };

    constructor(name, type, opts) {
        this.name = name;
        this.type = type;
        Object.assign(this, opts);

        this.isInitialised = false;
    }

    get tilesWide() {
        if (!this.isInitialised) this.initTiles();
        return this._tilesWide;
    }

    get tilesHigh() {
        if (!this.isInitialised) this.initTiles();
        return this._tilesHigh;
    }

    get tiles() {
        if (!this.isInitialised) this.initTiles();
        return this._tiles;
    }

    initTiles() {
        this.isInitialised = true;
        this._tiles = [];

        if (this.type === Tileset.type.imageTiles) {
            this.texture = new Texture.from(this.name);
            this.texture.baseTexture.scaleMode = SCALE_MODES.NEAREST;

            this._tilesWide = this.texture.width / this.tileWidth;
            this._tilesHigh = this.texture.height / this.tileHeight;
        }

        for (let y = 0; y < this._tilesHigh; y++) {
            for (let x = 0; x < this._tilesWide; x++) {
                const texture = new Texture(this.texture, new Rectangle(
                    this.texture.frame.x + (x * this.tileWidth),
                    this.texture.frame.y + (y * this.tileHeight),
                    this.tileWidth,
                    this.tileHeight
                ));
                this._tiles.push(texture);
            }
        }
    }
}
